var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c("fieldset", { staticClass: "form__group" }, [
        _c("legend", [
          _vm._v(
            "The following " +
              _vm._s(_vm.imported.length > 1 ? "users" : "user") +
              " will be added to the " +
              _vm._s(_vm.member ? _vm.member.name : "Unknown company") +
              "\n\t\t\tprofile\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "imported" },
          _vm._l(_vm.imported, function (user) {
            return _c("li", { staticClass: "imported__user" }, [
              _c("span", { staticClass: "user__name" }, [
                _vm._v(_vm._s(user.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "user__email" }, [
                _vm._v(_vm._s(user.email)),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form__group form__group--submit" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: ["submit"],
                  expression: '["submit"]',
                  arg: "disabled",
                },
              ],
              staticClass: "btn",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.back.apply(null, arguments)
                },
              },
            },
            [_vm._v("Back")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "wait",
                  rawName: "v-wait:disabled",
                  value: ["submit"],
                  expression: '["submit"]',
                  arg: "disabled",
                },
              ],
              staticClass: "btn btn--primary",
            },
            [_vm._v("Confirm")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }